import React, {useMemo} from 'react';
import type {DataFormPartRenderer} from 'schema/types';
import type {Product, ProductOwner} from 'services/metadata/types';
import {useLocalization} from 'localization';
import {CodeListField} from 'components';
import {useUniqueFieldId} from 'components/fields/hooks/useUniqueFieldId';
import {useDataFormContext} from 'schema/form/contexts';
import {getProductOwnerDistributionLabels} from './functions/getProductOwnerDistributionLabels';

export const DataFormProductOwners: DataFormPartRenderer = ({
  valuePath,
  useValue,
}) => {
  const {id} = useDataFormContext();
  const {t} = useLocalization();
  const fieldId = useUniqueFieldId(valuePath);
  const productOwners = useValue(valuePath, id) as ProductOwner[] | undefined;
  const products = useValue('products', id) as Product[] | undefined;
  const labels = useMemo(
    () =>
      getProductOwnerDistributionLabels(products ?? [], productOwners ?? []),
    [products, productOwners],
  );
  const options = useMemo(
    () => labels.map(label => ({code: label, value: label})),
    [labels],
  );
  const isSingle = labels.length === 1;

  return labels.length > 0 ? (
    <CodeListField
      id={fieldId}
      name={valuePath}
      label={t('form.global.field.productOwners.distribution.label')}
      cardinality={isSingle ? 'single' : 'multiple'}
      value={isSingle ? labels[0] : labels}
      options={options}
      readonly
    />
  ) : null;
};
